/*  React  */
import { useEffect, useState } from 'react';

export const useWindowSize = () => {
    const [windowSize, setWindowSize] = useState([0, 0]);

    useEffect(() => {
        if (typeof window === 'undefined') return null;

        const updateSize = () => {
            // requestAnimationFrame is still the best option rather than setTimeout and setInterval.
            // mainly because it is synced to the display refresh rate.
            requestAnimationFrame(() => {
                setWindowSize([window.innerWidth, window.innerHeight]);
            });
        };

        window.addEventListener('resize', updateSize);

        updateSize();

        return () => window.removeEventListener('resize', updateSize);
    }, []);

    return { windowSize };
};
